module.exports = __webpack_public_path__ + "img/img-23.a3169062.jpeg";